export default __webpack_public_path__ + "static/media/completedBadge.373eb02b.svg";